module.exports = "import React from 'react';\nimport { Level, LevelItem } from '@patternfly/react-core';\n\nclass SimpleLevel extends React.Component {\n  render() {\n    return (\n      <Level>\n        <LevelItem>Level Item</LevelItem>\n        <LevelItem>Level Item</LevelItem>\n        <LevelItem>Level Item</LevelItem>\n      </Level>\n    );\n  }\n}\n\nexport default SimpleLevel;\n"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/~/raw-loader!../react-core/src/layouts/Level/examples/SimpleLevel.js
// module id = 464
// module chunks = 114276838955818 141669503851301